export default __webpack_public_path__ + "static/media/ISKO CLASS-1 EXAM PATTERN 2025.a6c04d1f.pdf";